export default __webpack_public_path__ + "static/media/banner-time-of-ascension.6967cf05.png";